import { render, staticRenderFns } from "./VideoPublisherUpload.vue?vue&type=template&id=46301849&scoped=true&"
import script from "./VideoPublisherUpload.vue?vue&type=script&lang=js&"
export * from "./VideoPublisherUpload.vue?vue&type=script&lang=js&"
import style0 from "./VideoPublisherUpload.vue?vue&type=style&index=0&id=46301849&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46301849",
  null
  
)

export default component.exports